<div class="slider-info" [class.disabled]="isDisabled">
  <div class="form-group">
    @if (prefixLabel) {
    <span class="prefix-label">
      {{ prefixLabel }}
    </span>
    }
    <div class="form-field true-false-toggle" data-cy="toggle">
      <label class="switch">
        @if (control) {
        <input
          [formControl]="control"
          type="checkbox"
          (change)="toggle($event)"
        />
        } @else {
        <input
          (change)="toggle($event)"
          [checked]="checked"
          type="checkbox"
          [disabled]="isDisabled"
        />
        }
        <span class="slider round"></span>
      </label>
    </div>
    <div class="toggle-form-label">
      <div class="field-label true-false-label">
        {{ label }}
      </div>
      @if (tooltip) {
      <mat-icon class="info-icon" (click)="openDialog()"> info </mat-icon>
      }
    </div>
  </div>
</div>
